<h3 class="card-title">
  {{ title | translate }}
</h3>
<div>
  @if (!edit) {
  <button
    mat-icon-button
    type="button"
    class="mat-icon-edit"
    (click)="startEditing()"
  >
    <mat-icon>edit</mat-icon>
  </button>
  } @else {
  <button mat-icon-button type="button" class="mat-icon-edit" (click)="save()">
    <mat-icon>save</mat-icon>
  </button>
  <button
    mat-icon-button
    type="button"
    class="mat-icon-edit"
    (click)="cancelEdit()"
  >
    <mat-icon class="danger">cancel</mat-icon>
  </button>

  }
</div>
